export enum QuickContactType {
  RESTAURANT = 'RESTAURANT',
  USER = 'USER',
}
